import { Group, Text, Badge, Select } from '@mantine/core'

// #1080 検索結果件数の表示。装飾的な灰色ボックスをやめ、テキスト+バッジのシンプルな表示に。
// label は省略時「検索結果」。検索ではない一覧(#1120 応募状況)は「応募件数」などを渡す。
// sortOptions([{ value, label, href, active }])を渡すと、同じ行の右端に並び替えセレクトを出す
// (案件一覧の並び替え)。選択すると href へ遷移するだけの静的なリンク集合として扱う。
export default function ResultCount({ count, label = '検索結果', sortOptions }) {
  const options = Array.isArray(sortOptions) ? sortOptions : []
  const current = options.find((o) => o.active)

  return (
    <Group justify="space-between" mb="md" wrap="wrap" gap="sm">
      <Group gap={8}>
        <Text fw={700} fz="lg">{label}</Text>
        <Badge size="lg" color="brand" variant="light" radius="sm">{count}件</Badge>
      </Group>
      {options.length > 0 && (
        <Select
          aria-label="並び替え"
          data={options.map((o) => ({ value: o.value, label: o.label }))}
          value={current?.value ?? null}
          allowDeselect={false}
          w={160}
          onChange={(value) => {
            const option = options.find((o) => o.value === value)
            if (option) window.location.href = option.href
          }}
        />
      )}
    </Group>
  )
}
